export const HTTP_REQUEST_TIMEOUT_MS = 60_000
